import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TurnstileService {
  private static readonly STORAGE_KEY = 'turnstileToken';
  private token: string | null = null;
  private readonly resetRequested$ = new Subject<void>();

  constructor() {
    this.token = this.readFromStorage();
  }

  onResetRequested(): Observable<void> {
    return this.resetRequested$.asObservable();
  }

  requestReset(): void {
    this.clearToken();
    this.resetRequested$.next();
  }

  setToken(token: string | null): void {
    this.token = token;
    if (token) {
      this.writeToStorage(token);
    } else {
      this.removeFromStorage();
    }
  }

  getToken(): string | null {
    if (this.token) {
      return this.token;
    }
    this.token = this.readFromStorage();
    return this.token;
  }

  clearToken(): void {
    this.token = null;
    this.removeFromStorage();
  }

  private readFromStorage(): string | null {
    try {
      return sessionStorage.getItem(TurnstileService.STORAGE_KEY);
    } catch {
      return null;
    }
  }

  private writeToStorage(token: string): void {
    try {
      sessionStorage.setItem(TurnstileService.STORAGE_KEY, token);
    } catch {
      // ignore storage errors (e.g. SSR or privacy mode)
    }
  }

  private removeFromStorage(): void {
    try {
      sessionStorage.removeItem(TurnstileService.STORAGE_KEY);
    } catch {
      // ignore storage errors
    }
  }
}
